import { styled, media } from '@payright/web-components';

export const SCMerchantDDOConsent = styled.div`
  display: flex;
  border-radius: 20px;
  flex-direction: column;
  row-gap: 30px;

  .consent-text-wrapper {
    display: flex;
    align-self: flex-start;
    justify-content: space-between;
    line-height: 1.2em;
    font-size: 0.9em;
    flex-direction: column;
    row-gap: 15px;

    .tmd {
      p {
        font-size: 0.9em;
        font-weight: bold;
      }
    }
  }

  .ddo-consent-buttons {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    row-gap: 15px;
    flex-direction: column-reverse;

    ${media.min.small} {
      flex-direction: row;
      column-gap: 15px;
    }
  }
`;

export default SCMerchantDDOConsent;
